import { useTranslation } from "react-i18next"

import { AlertTriangle } from "@/components/icons"
import { cn } from "@/lib/utils"

/**
 * AI-generated-content disclaimer for Segment Analysis plan surfaces. Reuses the
 * shared locale key so the wording matches Tender and the chat composer.
 */
export function SegmentAiDisclaimer({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <p className={cn("text-muted-foreground flex items-center gap-1.5 text-xs", className)}>
      <AlertTriangle className="size-3 shrink-0" />
      {t("questioninput.ai_generated_content_warning")}
    </p>
  )
}
